<template>
	<div>群发列表</div>
</template>

<script>
</script>

<style>
</style>
